import { Recipe } from '../types/Recipe';

// Fonction pour récupérer toutes les recettes du localStorage
export const getRecipes = (): Recipe[] => {
  const recipes = localStorage.getItem('recipes');
  return recipes ? JSON.parse(recipes) : [];
};

// Fonction pour ajouter une nouvelle recette
export const addRecipe = (recipe: Omit<Recipe, 'id' | 'createdAt' | 'updatedAt'>): Recipe => {
  const recipes = getRecipes();
  
  const newRecipe: Recipe = {
    ...recipe,
    id: Date.now().toString(),
    createdAt: new Date(),
    updatedAt: new Date()
  };
  
  localStorage.setItem('recipes', JSON.stringify([...recipes, newRecipe]));
  return newRecipe;
};

// Fonction pour mettre à jour une recette existante
export const updateRecipe = (id: string, recipeData: Partial<Recipe>): Recipe | null => {
  const recipes = getRecipes();
  const index = recipes.findIndex(recipe => recipe.id === id);
  
  if (index === -1) return null;
  
  const updatedRecipe: Recipe = {
    ...recipes[index],
    ...recipeData,
    updatedAt: new Date()
  };
  
  recipes[index] = updatedRecipe;
  localStorage.setItem('recipes', JSON.stringify(recipes));
  
  return updatedRecipe;
};

// Fonction pour supprimer une recette
export const deleteRecipe = (id: string): boolean => {
  const recipes = getRecipes();
  const filteredRecipes = recipes.filter(recipe => recipe.id !== id);
  
  if (filteredRecipes.length === recipes.length) return false;
  
  localStorage.setItem('recipes', JSON.stringify(filteredRecipes));
  return true;
};

// Fonction pour récupérer une recette par son ID
export const getRecipeById = (id: string): Recipe | null => {
  const recipes = getRecipes();
  const recipe = recipes.find(recipe => recipe.id === id);
  return recipe || null;
};
